export const StatusCode = {
  HTTP_404_NOT_FOUND: 404,
}
